import { HiChevronDown, HiChevronUp, HiDownload, HiX } from "react-icons/hi";
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useB2cOrders } from "./B2cOrders";
import apiService from "../../../Services/authenticationServices";
import { toast } from "react-toastify";
import split from '../../../Assets/split.svg'
import b2bService from "../../../Services/b2bServises";
import { convertUTCDate } from "../../../Utils/utilServices";
import { convertAmountToWords } from "../../../Utils/utilServices";
import CureBaylogo from "../../../Assets/CurebayLogo.svg";



const InvoiceModal = ({ isOpen, onClose, orderData, orderDetails }) => {
    if (!isOpen || !orderData) return null;

    const totalAmount = orderDetails?.reduce(
        (sum, item) => sum + item.unitPrice * item.quantity,
        0
    ) || 0;

    const discount = totalAmount - orderData.paidAmount;

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return `${date.toLocaleDateString("en-GB")} ${date.toLocaleTimeString()}`;
    };

    const formatAddress = (address1, address2, city, state, pinCode) => {
        return [address1, address2, city, state, pinCode].filter(Boolean).join(", ");
    };

    const amountInWords = orderData.paidAmount > 0
        ? `(${convertAmountToWords(orderData.paidAmount)})`
        : "";




    const downloadInvoice = () => {
        const printContents = document.getElementById('invoice-content').innerHTML;
        printDiv(printContents);
    };

    const printDiv = (div) => {
        let popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.write(`
      <html>
        <head>
          <title>Invoice #${orderData.orderId}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              color: #333;
              line-height: 1.5;
            }
            .invoice-container {
              max-width: 800px;
              margin: 0 auto;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
            }
            .header h1 {
              font-size: 24px;
              margin-bottom: 10px;
            }
            .patient-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
            }
            .patient-info-col {
              width: 48%;
            }
            .info-label {
              font-weight: bold;
              margin-bottom: 5px;
            }
            .info-value {
              margin-bottom: 10px;
            }
            .address {
              margin-bottom: 20px;
            }
            hr {
              border: 0;
              border-top: 1px solid #ddd;
              margin: 20px 0;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f6f5f1;
              font-weight: bold;
            }
            .total-row {
              font-weight: bold;
            }
            .amount-in-words {
              font-style: italic;
              text-align: right;
              margin-top: 5px;
            }
            .d-print-none {
              display: none;
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            ${div}
          </div>
        </body>
      </html>
    `);
        popupWin.document.close();
        popupWin.focus();
        setTimeout(function () {
            popupWin.print();
            popupWin.close();
        }, 500);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
            <div id="invoice-content" className="bg-white rounded-lg p-4 sm:p-8 w-full max-w-7xl relative overflow-scroll max-h-[90vh] print-content">

                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl d-print-none"
                >
                    <HiX />
                </button>

                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h2 className="text-2xl font-bold">Order Invoice</h2>
                    </div>
                    <img
                        src={CureBaylogo}
                        alt="CureBay Logo"
                        className="h-8"
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-4">
                    <div>
                        <p className="text-gray-600">Patient</p>
                        <p className="font-semibold">
                            {orderData.patientName}/{orderData.patientGender}/
                            {orderData.patientAge} Years ({orderData.patientId})
                        </p>
                    </div>
                    <div>
                        <p className="text-gray-600">Mobile</p>
                        <p className="font-semibold">{orderData.patientMobile}</p>
                    </div>
                    <div>
                        <p className="text-gray-600">Order ID</p>
                        <p className="font-semibold">{orderData.orderId}</p>
                    </div>
                    <div>
                        <p className="text-gray-600">Ordered Date</p>
                        <p className="font-semibold">{convertUTCDate(orderData.modifiedDate, 'MM/DD/YYYY hh:mm:ss')}</p>
                    </div>
                    <div>
                        <p className="text-gray-600">Transaction ID</p>
                        <p className="font-semibold">{orderData.refTxnId}</p>
                    </div>
                </div>
                <div className="mb-4">
                    <p className="text-gray-600 text-sm">Address</p>
                    <p className="font-semibold text-sm">
                        {formatAddress(
                            orderData.address1,
                            orderData.address2,
                            orderData.patientCityBook,
                            orderData.patientStateBook,
                            orderData.patientPinCodeBook
                        )}
                    </p>
                </div>

                <hr className="my-4" />

                <div className="overflow-x-auto text-sm mb-6">
                    <table className="min-w-full border border-gray-300">
                        <thead className="bg-gray-100">
                            <tr>
                                {[
                                    "Transaction Type",
                                    "Transaction ID",
                                    "Payable Amount",
                                    "Date Of Payment",
                                    "Payment Mode",
                                    "Service Provider/Doctor",
                                    "Discount Amount",
                                ].map((header, idx) => (
                                    <th key={idx} className="p-2 text-left border">
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="p-2 border">{orderData?.serviceName}</td>
                                <td className="p-2 border">{orderData.refTxnId}</td>
                                <td className="p-2 border">₹{orderData.paidAmount?.toFixed(2)}</td>
                                <td className="p-2 border">{convertUTCDate(orderData.paymentDateTime, 'MM/DD/YYYY hh:mm:ss')}</td>

                                <td className="p-2 border">{orderData.payMode || "Cash"}</td>
                                <td className="p-2 border">{orderData.hospitalName}</td>
                                <td className="p-2 border">₹{discount.toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 className="font-bold text-lg mb-2">Pharmacy Order Breakup</h3>
                <div className="overflow-x-auto text-sm mb-6">
                    <table className="min-w-full border border-gray-300">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="p-2 text-left border">Prescription Order</th>
                                <th className="p-2 text-left border">Quantity</th>
                                <th className="p-2 text-left border">Unit Price</th>
                                <th className="p-2 text-left border">Total Amount (INR)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails?.map((item, index) => (
                                <tr key={index}>
                                    <td className="p-2 border">{item.drugName}</td>
                                    <td className="p-2 border">{item.quantity}</td>
                                    <td className="p-2 border">₹{item.unitPrice?.toFixed(2)}</td>
                                    <td className="p-2 border">
                                        ₹{(item.quantity * item.unitPrice)?.toFixed(2)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="flex justify-end">
                    <div className="w-full md:w-1/2 text-sm">
                        <div className="flex justify-between mb-2 font-semibold">
                            <span>Total (INR):</span>
                            <span>₹{totalAmount.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between mb-2 font-semibold">
                            <span>CureBay Discount (INR):</span>
                            <span>₹{discount.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between text-lg font-bold border-t pt-2">
                            <span>Payable Amount (INR):</span>
                            <span>₹{orderData.paidAmount?.toFixed(2)}</span>
                        </div>
                        <p className="text-right italic text-xs text-gray-600 mt-1">
                            {amountInWords}
                        </p>
                    </div>
                </div>

                <div className="flex justify-end mt-6 space-x-3 d-print-none">
                    <button
                        onClick={downloadInvoice}
                        className="flex items-center gap-2 border border-blue-500 text-blue-600 px-4 py-2 rounded hover:bg-blue-100"
                    >
                        <HiDownload />
                        Download
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};




const OrderHeaderAccordion = ({
    data,
    index,
    isOpen,
    onToggle,
    selectedItems,
    onSelectItem,
    isConsignmentMode,
    onClose,
    onSelectAllItems,
    isGlobalSelectAll
}) => {
    const scrollRef = useRef(null);
    const bgColor = index % 2 === 0 ? "bg-[#f6f5f1]" : "bg-[#FFFFFF]";
    const [orderDetails, setOrderDetails] = useState([]);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [selectedConsignment, setSelectedConsignment] = useState(null);
    const [shouldSelectAllAfterFetch, setShouldSelectAllAfterFetch] = useState(false);

    const slaList = [
        { name: '0 -12 Hours', value: 1 },
        { name: '12-24 Hours', value: 2 },
        { name: '24-36 Hours', value: 3 },
        { name: '36-48 Hours', value: 4 },
        { name: '48-60 Hours', value: 5 },
        { name: '60-72 Hours', value: 6 },
        { name: '72 Hrs-1 Week', value: 7 },
        { name: 'Cannot be supplied', value: 8 },
        { name: 'CureBay Preferred Medicine ', value: 9 },
    ];

    const columns = [
        { field: 'checkBox', header: '' },
        { field: 'drugName', header: 'Drug Name' },
        { field: 'drugCode', header: 'Drug Code' },
        { field: 'drugsInfoComposition', header: 'Composition & Strength' },
        { field: 'drugsInfoTypeofsell', header: 'Package Size' },
        { field: 'quantity', header: 'Quantity' },
        { field: 'unitPrice', header: 'Unit Price' },
        { field: 'actualPrice', header: 'Payable Amount' },
        { field: 'consignmentStatus', header: 'Pdt.Status' },
        { field: 'deliverySlaStatus', header: 'SLA' },
        { field: 'deliverySlaTime', header: 'Committed ETA' },
        { field: 'deliverySlaETATime', header: 'ETA' },
        { field: 'consignmentId', header: 'Consignment ID' },
    ];

    const pdtStatuses = [
        { name: 'Yet to Packed', value: 0 },
        { name: 'Packed', value: 1 },
        { name: 'Shipped', value: 2 },
        { name: 'Order on the Bus', value: 3 },
        { name: 'Out for Delivery', value: 4 },
        { name: 'Delivered', value: 5 }
    ];

    const getStatusName = (value) => {
        const status = pdtStatuses.find(item => item.value === value);
        return status ? status.name : 'Yet to Packed';
    };

    const getSlaName = (value) => {
        const slaItem = slaList.find(item => item.value === value || '');
        return slaItem?.name ?? ''
    };

    const formatAddress = (...parts) => parts.filter(Boolean).join(", ");

    const isShipmentFullySelected = data.items?.every(item =>
        selectedItems.some(s => s.itemId === item.itemDetailsId)
    );


    const fetchData = async () => {
        try {
            if (data?.items) {
                const transformedItems = data.items.map(item => ({
                    id: item.itemCode,
                    itemDetailsId: item.itemDetailsId,
                    drugName: item.itemName,
                    drugCode: item.itemCode,
                    quantity: item.quantity,
                    unitPrice: item.price / item.quantity,
                    consignmentStatus: item.shipmentStatus,
                    totalAmount: item.price,
                    drugsInfoComposition: '-',
                    drugsInfoTypeofsell: '-',
                    deliverySlaStatus: '-',
                    deliverySlaTime: '-',
                    deliverySlaETATime: '-',
                    consignmentId: '-'
                }));
                setOrderDetails(transformedItems);
                setShouldSelectAllAfterFetch(false);
            } else {
                setOrderDetails([]);
                setShouldSelectAllAfterFetch(false);
                toast.info("No order details found for this shipment.");
            }
        } catch (err) {
            console.error('Error processing order details:', err);
            toast.error("An error occurred while processing order details.");
        }
    };


    const copyConfirmTab = (item, index) => {
        const newOrderDetails = [...orderDetails];
        const copiedItem = { ...newOrderDetails[index] };

        newOrderDetails[index].disabled = true;
        newOrderDetails[index].copiedFrom = 'Y';

        copiedItem.id = null;
        copiedItem.copiedqty = copiedItem.quantity;
        copiedItem.quantity = 0;
        copiedItem.copiedindex = index;
        copiedItem.disabled = false;
        copiedItem.copiedFrom = 'N';
        newOrderDetails.push(copiedItem);
        setOrderDetails(newOrderDetails);
    };

    const handleQuantityChange = (item, value, index) => {
        const numericValue = parseInt(value) || 0;
        const originalIndex = item.copiedindex;

        const originalItem = orderDetails[originalIndex];

        if (!originalItem) {
            setOrderDetails(prev => {
                const newDetails = [...prev];
                newDetails[index].quantity = numericValue;
                newDetails[index].actualPrice = numericValue * (item.unitPrice || item.modifiedTotalAmount / item.quantity);
                return newDetails;
            });
            return;
        }

        if (numericValue > item.copiedqty) {
            toast.error('Split Qty greater than actual Qty');

            setOrderDetails(prev => {
                const newDetails = [...prev];
                newDetails[index].quantity = 0;
                newDetails[index].actualPrice = 0;

                newDetails[originalIndex].quantity = item.copiedqty;
                newDetails[originalIndex].actualPrice =
                    item.copiedqty * (originalItem.unitPrice || originalItem.modifiedTotalAmount / originalItem.quantity);

                return newDetails;
            });
            return;
        }

        setOrderDetails(prev => {
            const newDetails = [...prev];

            newDetails[index].quantity = numericValue;
            newDetails[index].actualPrice = numericValue * (item.unitPrice || item.modifiedTotalAmount / item.quantity);

            newDetails[originalIndex].quantity = item.copiedqty - numericValue;
            newDetails[originalIndex].actualPrice =
                (item.copiedqty - numericValue) * (originalItem.unitPrice || originalItem.modifiedTotalAmount / originalItem.quantity);

            return newDetails;
        });
    };

    const saveChanges = async () => {
        try {


            const response = await apiService.updateOrderDetails(orderDetails);
            if (response.data.responseCode === '200') {
                toast.success('Changes saved successfully');
                fetchData();
            } else {
                toast.error(response.data.message || 'Failed to save changes');
            }
        } catch (err) {
            console.error(err);
            toast.error('Failed to save changes');
        }
    };

    const isAllSelected = orderDetails.length > 0 && orderDetails.every(item =>
        selectedItems.some(selected =>
            selected.orderId === data.orderId &&
            selected.itemId === item.itemDetailsId &&
            selected.drugCode === item.drugCode
        )
    );

    const handleItemSelect = (rowItem, isChecked) => {
        const payload = {
            orderId: data.orderId,
            itemId: rowItem.itemDetailsId,
            orderDetailsId: rowItem.itemDetailsId,
            drugCode: rowItem.drugCode,
            quantity: rowItem.quantity,
        };

        onSelectItem(payload, isChecked, data.orderId);
    };


    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allItems = orderDetails.map((item) => ({
                orderId: data.orderId,
                itemId: item.itemDetailsId,
                modifiedBy: localStorage.getItem('userCode'),
                orderDetailsId: item.itemDetailsId,
                drugCode: item.drugCode,
                quantity: item.quantity,
            }));

            onSelectAllItems(data.orderId, allItems, true);
        } else {
            onSelectAllItems(data.orderId, [], false);
        }
    };

    useEffect(() => {
        if (shouldSelectAllAfterFetch) {
            handleSelectAll(true);
            setShouldSelectAllAfterFetch(false);
        }
    }, [orderDetails]);

    const handleHeaderCheckboxChange = (e) => {
        e.stopPropagation();
        const isChecked = e.target.checked;

        const itemsToSelect = data.items?.map(item => ({
            orderId: data.orderId,
            itemId: item.itemDetailsId,
            modifiedBy: localStorage.getItem('userCode'),
            orderDetailsId: item.itemDetailsId,
            drugCode: item.itemCode,
            quantity: item.quantity
        })) || [];

        onSelectAllItems(data.orderId, itemsToSelect, isChecked);
    };


    useEffect(() => {
        if (isOpen && data?.items) {
            scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            fetchData();
        }
    }, [isOpen, data]);

    const headerFields = [
        {
            label: "",
            value: (
                <div onMouseDown={(e) => e.stopPropagation()}>
                    <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleHeaderCheckboxChange}
                        onClick={(e) => e.stopPropagation()}
                        className="cursor-pointer accent-[#1d2f5b]"
                    />
                </div>
            ),
            width: "w-[3%]"
        },
        { label: "Shipment No", value: data.shipmentPackageNo, width: "w-[45%] sm:w-[12%]" },
        { label: "Order ID", value: data.orderId, width: "w-[45%] sm:w-[12%]" },
        { label: "Patient Name", value: data.patientName, width: "w-[45%] sm:w-[12%]" },
        { label: "Mobile No.", value: data.patientMobile, width: "w-[45%] sm:w-[12%]" },
        {
            label: "Patient Address",
            value: formatAddress(data.address),
            width: "w-[45%] sm:w-[20%]",
        },
        { label: "Eclinic", value: data.b2cBranchName ?? "Null", width: "w-[45%] sm:w-[10%]" },
    ];

    return (
        <div ref={scrollRef} className={`border rounded ${bgColor} my-3`}>
            <div className="cursor-pointer px-2 sm:px-4 flex justify-between items-center">
                <div className="flex flex-wrap sm:flex-nowrap overflow-auto text-xs p-2 sm:p-4 gap-3 sm:gap-5">
                    {headerFields.map(({ label, value, width }, i) => (
                        <span
                            key={i}
                            className={`${width} break-words`}
                            onClick={i === 0 ? undefined : () => onToggle()}
                        >
                            <span className="text-gray-500">{label}</span> {value}
                        </span>
                    ))}
                </div>
                <span
                    className="text-gray-600 text-xl"
                    onClick={() => onToggle()}
                >
                    {isOpen ? <HiChevronUp /> : <HiChevronDown />}
                </span>
            </div>

            {isOpen && <div className="h-[1px] bg-gray-300 w-full" />}

            {isOpen && (
                <div className="p-4 pb-8 bg-white overflow-auto">
                    <div className="flex flex-wrap sm:flex-nowrap overflow-auto gap-2 sm:gap-4 mb-4 text-sm">
                        {data.defaultSla && (
                            <div className="w-full sm:w-[15%] break-words">
                                <p className="text-gray-500">
                                    Delivery SLA: <span> {getStatusName(data.defaultSla)}</span>
                                </p>
                            </div>
                        )}
                        {data.shipTo && (
                            <div className="w-full sm:w-[15%] break-words">
                                <p className="text-gray-500">
                                    Ship To: <span>{data.shipTo}</span>
                                </p>
                            </div>
                        )}
                        {data.shippingName && (
                            <div className="w-full sm:w-[20%] break-words">
                                <p className="text-gray-500">
                                    Shipping Name: <span>{data.shippingName}</span>
                                </p>
                            </div>
                        )}
                        {data.shippingAddress && (
                            <div className="w-full sm:w-[50%] break-words">
                                <p className="text-gray-500">
                                    Shipping Address: <span>{data.shippingAddress}</span>
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="flex flex-wrap gap-2 justify-between mb-3">
                        <button
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
                            onClick={() => setShowInvoiceModal(true)}
                        >
                            Open Invoice
                        </button>
                        <div className="flex items-center gap-6">

                            <button
                                className="bg-[#336b3b] text-white px-4 py-2 rounded-md"
                                onClick={saveChanges}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>

                    <div className="overflow-x-auto border border-[#1d2f5b] rounded-md">
                        <div className="min-w-full inline-block align-middle">
                            <div className="overflow-x-auto">
                                <table className="min-w-full text-sm text-left">
                                    <thead className="bg-[#1d2f5b] text-white">
                                        <tr>
                                            {columns.map((column, index) => (
                                                <th key={index} className="p-2 font-semibold">
                                                    {column.header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderDetails.map((item, index) => (
                                            <tr key={item.id || index} className="border-t">
                                                {columns.map((column) => {
                                                    if (column.field === 'checkBox') {
                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap">
                                                                <div
                                                                    onMouseDown={(e) => e.stopPropagation()}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedItems.some(
                                                                            (s) => s.orderId === data.orderId && s.itemId === item.itemDetailsId
                                                                        )}
                                                                        onChange={(e) => handleItemSelect(item, e.target.checked)}
                                                                        className="cursor-pointer accent-[#1d2f5b]"
                                                                    />

                                                                </div>
                                                            </td>
                                                        );
                                                    }
                                                    else if (column.field === 'deliverySlaStatus') {
                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap">
                                                                {getSlaName(item.deliverySlaStatus ?? item.defaultSla)}
                                                            </td>
                                                        );
                                                    }
                                                    else if (column.field === 'deliverySlaETATime') {
                                                        const slaColor =
                                                            item.deliverySlaColourStatus === 2 ? 'green' :
                                                                item.deliverySlaColourStatus === 1 ? 'red' :
                                                                    '';

                                                        const style = {
                                                            color: slaColor,
                                                            fontWeight: 'bold'
                                                        };

                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap" style={style}>
                                                                {item[column.field]}
                                                            </td>
                                                        );
                                                    } else if (column.field === 'consignmentStatus') {
                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap">
                                                                {getStatusName(item[column.field])}
                                                            </td>
                                                        );
                                                    }
                                                    else if (column.field === 'quantity') {
                                                        return (
                                                            <td key={column.field}>
                                                                <input
                                                                    type="text"
                                                                    value={item.quantity}
                                                                    onChange={(e) => {
                                                                        const val = Math.max(0, parseInt(e.target.value) || 0);
                                                                        handleQuantityChange(item, val, index);
                                                                    }}
                                                                    className="w-20 border rounded px-2 py-1"
                                                                    min="0"
                                                                    disabled={item.disabled}
                                                                />
                                                            </td>
                                                        );
                                                    } else if (column.field === 'consignmentId') {
                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap">
                                                                {item[column.field] ? (
                                                                    <button
                                                                        type="button"
                                                                        className="text-blue-600 hover:underline"
                                                                        onClick={() => setSelectedConsignment(item[column.field])}
                                                                    >
                                                                        {item[column.field]}
                                                                    </button>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>
                                                        );
                                                    } else {
                                                        return (
                                                            <td key={column.field} className="p-2 whitespace-nowrap">
                                                                {item[column.field] || '-'}
                                                            </td>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <InvoiceModal
                isOpen={showInvoiceModal}
                onClose={() => setShowInvoiceModal(false)}
                orderData={data}
                orderDetails={orderDetails}
            />
        </div>
    );
};

const B2cShipmentRecevied = forwardRef((props, ref) => {
    const [openIndex, setOpenIndex] = useState(null);
    const [orders, setOrders] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isConsignmentMode, setIsConsignmentMode] = useState(false);
    const [sortOrder, setSortOrder] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(true);
    const { filter, setFilterField } = useB2cOrders();
    const [isGlobalSelectAll, setIsGlobalSelectAll] = useState(false);

    const hasOrderId = filter.orderId && filter.orderId.trim() !== "";

    const showSelectAll = hasOrderId;

    const selectedIdLabel = hasOrderId
        ? filter.orderId
        : "";

    const handleSelectItem = (itemObj, isChecked) => {
        setSelectedItems(prev => {
            let updated;

            if (isChecked) {
                const exists = prev.some(s => s.itemId === itemObj.itemId);
                updated = exists ? prev : [...prev, itemObj];
            } else {
                updated = prev.filter(s => s.itemId !== itemObj.itemId);
            }

            setIsGlobalSelectAll(areAllItemsSelected(orders, updated));

            return updated;
        });
    };


    const fetchData = async (pageNo = 1) => {
        try {

            setSelectedItems([]);
            setIsGlobalSelectAll(false);

            let payload = {
                pageNumber: pageNo,
                pageSize: 10,
                sortBy: sortOrder === 0 ? 'ASC' : 'DESC',
                searchText: filter.orderId || "",
                searchString: filter.searchString || '',
                orderSource: "B2C",
                sourceChannel: "B2C",
                circleCode: "N",
                state: "OD",
                ...Object.fromEntries(
                    Object.entries(filter).filter(
                        ([key, val]) => val !== null && val !== undefined && val !== "" && key !== "orderId"
                    )
                ),
            };

            if (payload.fromDate && payload.toDate) {
                payload.fromDate = convertUTCDate(payload.fromDate);
                payload.toDate = convertUTCDate(payload.toDate);
            }

            const response = await apiService.getShipmentList(payload);
            setIsGlobalSelectAll(false);

            if (response?.data?.shipments) {
                setOrders(response.data.shipments);
                setCurrentPage(pageNo);
                setHasNextPage(pageNo < response.data.totalPages);
            } else {
                setOrders([]);
                setHasNextPage(false);
            }
        } catch (err) {
            console.error("Failed to fetch orders", err);
            setOrders([]);
            setHasNextPage(false);
            toast.error("Failed to fetch orders");
        }
    };

    const handleCreateConsignment = async () => {
        if (selectedItems.length === 0) {
            toast.error("Please select at least one item to create consignment");
            return;
        }

        try {
            const transformedItems = selectedItems.map(item => ({
                orderId: item.orderId,
                itemId: item.itemId || item.orderDetailsId,
                modifiedBy: localStorage.getItem('userCode'),
                orderDetailsId: item.orderDetailsId,
                drugCode: item.drugCode,
                quantity: item.quantity
            }));

            const response = await b2bService.createConsignment(transformedItems, 'CHE');

            if (response.responseCode === '200') {
                toast.success('Consignment created successfully.');
                setSelectedItems([]);
                packConsignment(response.successObject.consignmentId);
                const updatedResponse = await apiService.getShipmentList({
                    pageNumber: currentPage,
                    pageSize: 10,
                    sortBy: sortOrder === 0 ? 'ASC' : 'DESC',
                    searchText: filter.orderId || "",
                    circleCode: "N",
                    orderSource: "B2C",
                    sourceChannel: "B2C",
                    state: "OD",
                    ...Object.fromEntries(
                        Object.entries(filter).filter(
                            ([key, val]) => val !== null && val !== undefined && val !== "" && key !== "orderId"
                        )
                    ),
                });

                if (updatedResponse?.data?.shipments) {
                    setOrders(updatedResponse.data.shipments);
                }
            } else {
                toast.error(response.responseMessage || "Failed to create consignment");
            }
        } catch (error) {
            console.error("Consignment creation error:", error);
            toast.error("Failed to create consignment");
        }
    };

    const packConsignment = async (consignmentId) => {
        if (!consignmentId) {
            toast.error('Please select consignment id');
            return;
        }

        let user = JSON.parse(localStorage.getItem('loginObj'));
        let payload = {
            "consignmentId": consignmentId,
            "statusName": "PACKED",
            "userName": user.salutation + user.firstName + user.lastName,
            "userId": localStorage.getItem('userCode'),
            "createdBy": localStorage.getItem('userCode'),
            "modifiedBy": localStorage.getItem('userCode'),
            "status": "1",
            "source": 'B2C'
        };

        try {
            const response = await b2bService.packConsignment(payload);
            if (response.responseCode == '200') {
                toast.success('Status Updatated Successfully.');
                fetchData(currentPage);
                let x = openIndex
                setOpenIndex(null)
                setTimeout(() => {
                    setOpenIndex(x)

                }, 500);


            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error("Packing error:", error);
            toast.error("Failed to pack consignment");
        }
    };

    const handleNextPage = () => {
        fetchData(currentPage + 1);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            fetchData(currentPage - 1);
        }
    };

    useEffect(() => {
        fetchData(1);
    }, [filter, sortOrder]);

    useImperativeHandle(ref, () => ({
        onSearch: () => fetchData(1),
    }));

    const handleToggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    const handleSortChange = (value) => {
        setSortOrder(value);
    };

    const areAllItemsSelected = (orders, selectedItems) => {
        const allItemIds = orders.flatMap(order =>
            order.items?.map(item => item.itemDetailsId) || []
        );

        if (allItemIds.length === 0) return false;

        return allItemIds.every(id =>
            selectedItems.some(s => s.itemId === id)
        );
    };


    const handleSelectAllItems = (orderId, orderDetails, isChecked) => {
        if (isChecked) {
            setSelectedItems((prev) => {
                const filtered = prev.filter((s) => s.orderId !== orderId);
                return [...filtered, ...orderDetails];
            });
        } else {
            setSelectedItems((prev) =>
                prev.filter((s) => s.orderId !== orderId)
            );
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allItems = orders.flatMap(order =>
                order.items?.map(item => ({
                    orderId: order.orderId,
                    itemId: item.itemDetailsId,
                    modifiedBy: localStorage.getItem("userCode"),
                    orderDetailsId: item.itemDetailsId,
                    drugCode: item.itemCode,
                    quantity: item.quantity
                })) || []
            );

            setSelectedItems(allItems);
            setIsGlobalSelectAll(true);
        } else {
            setSelectedItems([]);
            setIsGlobalSelectAll(false);
        }
    };

    return (
        <div className="pl-1 pr-1 sm:pr-6 min-h-screen">
            <div className="flex flex-wrap items-center gap-4 ml-4 mb-4">
                <label className="flex items-center gap-2">
                    <input
                        type="radio"
                        name="sortOrder"
                        value="newest"
                        checked={sortOrder === 1}
                        onChange={() => handleSortChange(1)}
                        className="h-4 w-4 text-blue-600"
                    />
                    <span>Newest First</span>
                </label>
                <label className="flex items-center gap-2">
                    <input
                        type="radio"
                        name="sortOrder"
                        value="oldest"
                        checked={sortOrder === 0}
                        onChange={() => handleSortChange(0)}
                        className="h-4 w-4 text-blue-600"
                    />
                    <span>Oldest First</span>
                </label>
            </div>

            <div className="flex flex-wrap justify-end mb-3 gap-2">
                {showSelectAll && (
                    <div className="ml-4">
                        <label className="flex items-center gap-2">
                            <input
                                type="checkbox"
                                checked={isGlobalSelectAll}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                                className="h-4 w-4 cursor-pointer accent-[#1d2f5b]"
                            />
                            <span className="text-sm font-medium">
                                <span className="text-gray-500">Select all shipments for </span>
                                <span className="text-blue-600">{selectedIdLabel}</span>
                            </span>
                        </label>
                    </div>
                )}
                <div className="ml-auto">
                    <button
                        className="bg-[#336b3b] hover:bg-[#336b3b] text-white px-4 py-2 rounded-md transition-colors duration-200 flex items-center gap-1"
                        onClick={handleCreateConsignment}
                        disabled={selectedItems.length === 0}
                    >
                        Create Consignment
                        {selectedItems.length > 0 && (
                            <span className="bg-white text-[#336b3b] rounded-full w-5 h-5 flex items-center justify-center text-xs ml-1">
                                {selectedItems.length}
                            </span>
                        )}
                    </button>
                </div>
            </div>

            {orders.map((order, index) => (
                <OrderHeaderAccordion
                    key={index}
                    data={order}
                    index={index}
                    isOpen={openIndex === index}
                    onToggle={() => handleToggle(index)}
                    selectedItems={selectedItems}
                    onSelectItem={handleSelectItem}
                    isConsignmentMode={isConsignmentMode}
                    onClose={fetchData}
                    onSelectAllItems={handleSelectAllItems}
                    isGlobalSelectAll={isGlobalSelectAll}
                />
            ))}

            <div className="flex flex-wrap justify-center items-center mt-4 mb-8 gap-2">
                <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="px-4 py-2 border rounded disabled:opacity-50"
                >
                    Previous
                </button>

                <button
                    onClick={() => fetchData(1)}
                    className={`px-4 py-2 border rounded ${currentPage === 1 ? 'bg-blue-100' : ''}`}
                >
                    1
                </button>

                {currentPage > 1 && (
                    <button
                        onClick={() => fetchData(currentPage)}
                        className="px-4 py-2 border rounded bg-blue-100"
                    >
                        {currentPage}
                    </button>
                )}

                <button
                    onClick={handleNextPage}
                    disabled={!hasNextPage}
                    className="px-4 py-2 border rounded disabled:opacity-50"
                >
                    Next
                </button>
            </div>
        </div>
    );
});

export default B2cShipmentRecevied;
